<template>
	<span>
		<!-- Gatilho: o slot permite trocar o botão sem reescrever o modal !-->
		<slot :handlers="{ open: handleOpen }">
			<!-- Ícone no slot: a prop icon do ActionButton só espaça quando o slot tem
				 um componente, e aqui o conteúdo é texto !-->
			<ActionButton @click="handleOpen">
				<i class="fal fa-box mr-2"></i>
				{{ label }}
			</ActionButton>
		</slot>
		<!-- Resumo !-->
		<ModalContainer v-model="showSummary" overlay freeze-scroll>
			<ShipmentSummaryModal :shipment="shipment" :shipment-id="shipmentId" @close="showSummary = false"/>
		</ModalContainer>
	</span>
</template>

<script>
import ActionButton from "@/components/ActionButton.vue"
import ModalContainer from "@/components/ModalContainer.vue"
import ShipmentSummaryModal from "@/domain/shipments/ShipmentSummaryModal.vue"

export default {
	name: "ShipmentSummaryButton",
	components: {ActionButton, ModalContainer, ShipmentSummaryModal},
	props: {
		/**
		 * Remessa já carregada. Quando ausente, o modal busca pelo shipmentId
		 */
		shipment: Object,
		shipmentId: [Number, String],
		label: {
			type: String,
			default: "Resumo da remessa"
		}
	},
	data() {
		return {
			showSummary: false
		}
	},
	methods: {
		/**
		 * Handle open
		 */
		handleOpen() {
			this.showSummary = true
			this.$emit('open')
		}
	}
}
</script>
